<template>
    <!-- 作息广播管理 -->
    <div class="inside_pages_right_top">
        <ul>
            <li :class="{inside_pages_right_top_action:$Common.getThisTopPage()=='/today_broadcast'}"  @click="$Common.pageJump('/today_broadcast',3)">
                今日广播
            </li>
            <li :class="{inside_pages_right_top_action:$Common.getThisTopPage()=='/rest_broadcast'}" @click="$Common.pageJump('/rest_broadcast',3)">
                作息广播
            </li>
            <li :class="{inside_pages_right_top_action:$Common.getThisTopPage()=='/rest_broadcast_settings'}" @click="$Common.pageJump('/rest_broadcast_settings',3)">
                作息表设置
            </li>
            <li :class="{inside_pages_right_top_action:$Common.getThisTopPage()=='/rest_broadcast_settings_task'}" @click="$Common.pageJump('/rest_broadcast_settings_task',3)">
                作息表任务设置
            </li>
            <!-- <li :class="{inside_pages_right_top_action:$Common.getThisTopPage()=='/time_broadcast'}" @click="$Common.pageJump('/time_broadcast',3)">
                校园定时广播
            </li> -->
        </ul>

    </div>
</template>

<script>
export default {
    name:'RestBroadcastManagement',
    components: {},
    props: {},
    data() {
        return {
        };
    },
    watch: {
    },
    computed: {
    },
    methods: {
       
    },
    created() {
    },
    mounted() {
    },
};
</script>
<style scoped>
</style>